import { roomsServices } from "../../Services/RoomServices/rooms.services";


const roomListing = async (params) => {
    let response = await roomsServices.roomsListing(params);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const roomCreate = async () => {
    let post = {
        "title": "new test in room h d 123",
        "available_beds": "100",
        "hospital_id": "10",
        "ward_id": "13"
    }
    let response = await roomsServices.roomsCreate(post);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const roomDetail = async (id) => {
    let response = await roomsServices.roomsDetail(id);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const roomUpdate = async (id) => {
    let response = await roomsServices.roomsUpdate(id);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const roomDelete = async (id) => {
    let response = await roomsServices.roomsDelete(id);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const roomsController = {
    roomListing,
    roomCreate,
    roomDetail,
    roomUpdate,
    roomDelete,
};

export default roomsController;
